import { createSelector } from 'reselect';

import { usersResource } from '../resources';

import selectAuthPrevUser from './selectAuthPrevUser';
import selectSettings from './selectSettings';

const selectPrevUser = createSelector(
  usersResource.selectEntitiesObj,
  selectAuthPrevUser,
  selectSettings,
  (users, id, settings) => {
    const res = users[id];
    if (!res) {
      return null;
    }
    return {
      ...res,
      settings: settings[res.setting],
    };
  },
);

export default selectPrevUser;
